import React from "react";

const FiltersSkeleton = () => {
  return (
    <>
      {[...Array(10)].map((_, index) => (
        <div key={index} className="animate-pulse mb-4">
          <div className="w-24 h-6 bg-gray-300 rounded mb-2"></div>
          <div className="flex items-center gap-2">
            <div
              className={`h-8 bg-gray-300 rounded ${
                Math.random() > 0.5 ? "w-48" : "w-60"
              }`}
            ></div>
          </div>
        </div>
      ))}
    </>
  );
};

export default FiltersSkeleton;
